import { Injectable } from '@angular/core';
import { OclDecisionTagService } from '../../../ocl/services/ocl-decision-tag-service/ocl-decision-tag.service';

@Injectable({
  providedIn: 'root',
})
export class GocDecisionTagService extends OclDecisionTagService {
  // tslint:disable:variable-name
  protected ParseDecisionTag = Parse.Object.extend('GOCDecisionTag');
  protected ParseDecision = Parse.Object.extend('GOCDecisions');
  protected ParseTag = Parse.Object.extend('GOCTag');
  // tslint:enabled
}
